/* eslint-disable no-unused-vars */

const xhs = ({
})
const cyMap = new Map([[1, '文莱'], [2, '泰国'], [3, '越南'], [4, '印度尼西亚'], [5, '马来西亚'], [6, '菲律宾'], [7, '柬埔寨'],
  [8, '新加坡'], [9, '老挝'], [10, '缅甸']])
const eyMap = new Map([[1, 'Brunei'], [2, 'Thailand'], [3, 'Vietnam'], [4, 'Indonesia'], [5, 'Malaysia'], [6, 'Phillipine'], [7, 'Cambodia'],
  [8, 'Singapore'], [9, 'Lao'], [10, 'Myanmar']])
xhs.cy = (code, lang) => {
  //
  if (lang === 'cn') {
    return cyMap.get(code)
  }
  if (lang === 'en') {
    return eyMap.get(code)
  }
}
/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
xhs.idxGroup = (data, id, label) => {
  var map = {}
  var dest = []
  for (var i = 0; i < data.length; i++) {
    var ai = data[i]
    if (!map[ai[id]]) {
      dest.push({
        [id]: ai[id],
        [label]: ai[label],
        data: [ai]
      })
      map[ai[id]] = ai
    } else {
      for (var j = 0; j < dest.length; j++) {
        var dj = dest[j]
        if (dj[id] === ai[id]) {
          dj.data.push(ai)
          break
        }
      }
    }
  }
  return dest
}
export default xhs
